import { render, staticRenderFns } from "./preventivatore.html?vue&type=template&id=6614c90e&scoped=true&"
import script from "./Preventivatore.vue?vue&type=script&lang=js&"
export * from "./Preventivatore.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/preventivi/preventivatore.css?vue&type=style&index=0&id=6614c90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6614c90e",
  null
  
)

export default component.exports